var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", {
    staticClass: "something",
    on: { dragover: _vm.dragover, dragleave: _vm.dragleave, drop: _vm.drop },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }